import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, DEPENDENT_TABLES as depTableNames, CRUMB_LABEL_KEY, PROrdersParts } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
	},
	edit: {
		Id: null as number | null,
	},
	depTableNames,
	depTableSettings: {
		[PROrdersParts]: {
			loadByEntityId: true,
			filter(state) {
				return {
					Id: state.props.id, wantRows: true,
				};
			},
		},
	},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		id: 0 as number,
		mode: null,
		filter: {
			Id: null as number | null,
		},
	},
});
